export type HardwareTypes = 'disk' | 'vcpu' | 'memory' | 'bandwidth'

export type HardwareTypesFunction = {[key in HardwareTypes]: (value: number) => string}

export const hardwareTypesFunction: HardwareTypesFunction = {
    'disk': formatDiskLabel,
    'memory': formatMemoryLabel,
    'bandwidth': formatBandwidthLabel,
    'vcpu': formatVCpuLabel,
}

function formatDiskLabel(disk: number) {
    return `${disk} GB`;
}

function formatMemoryLabel(memory: number) {    
    return memory < 1024 ? `${memory} MB` : `${getMemoryValueInGB(memory)} GB`    
}

function formatBandwidthLabel(bandwidth: number) {
    return `${bandwidth} Mb/s`;
}

export function formatVCpuLabel(vcpu: number) {
    const plural = (vcpu > 1)?'s':''
    return `${vcpu} vCPU${plural}`
}

function getMemoryValueInGB(value) {
    return (value % 1024 == 0 ? (value / 1024) : (value / 1024).toFixed(2))
}